import { post, WebService } from './utils';

export const getDocumentCabezal = async (rut: string, id: number) => {
  const url =
    'https://infrasistemas.sytes.net:7080/WebService.asmx?op=Documento_Cabezal';

  const sr = `<?xml version="1.0" encoding="utf-8"?>
  <soap12:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap12="http://www.w3.org/2003/05/soap-envelope">
    <soap12:Body>
      <Documento_Cabezal xmlns="http://infrasistemas.sytes.net:7080/">
        <RUT>${rut}</RUT>
        <FECabId>${id}</FECabId>
      </Documento_Cabezal>
    </soap12:Body>
  </soap12:Envelope>`;

  const getDocumentCabezalWS: WebService<string> = {
    url,
    name: 'Documento_Cabezal',
    resultSelector: 'Documento_CabezalResult',
    sr,
    transform: (response: string) => JSON.parse(response),
  };
  return post(getDocumentCabezalWS);
};

export const getDocumentLineas = async (rut: string, id: number) => {
  const url =
    'https://infrasistemas.sytes.net:7080/WebService.asmx?op=Documento_Lineas';

  const sr = `<?xml version="1.0" encoding="utf-8"?>
  <soap12:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap12="http://www.w3.org/2003/05/soap-envelope">
    <soap12:Body>
      <Documento_Lineas xmlns="http://infrasistemas.sytes.net:7080/">
        <RUT>${rut}</RUT>
        <FECabId>${id}</FECabId>
      </Documento_Lineas>
    </soap12:Body>
  </soap12:Envelope>`;

  const getDocumentLineasWS: WebService<string> = {
    url,
    name: 'Documento_Lineas',
    resultSelector: 'Documento_LineasResult',
    sr,
    transform: (response: string) => JSON.parse(response),
  };
  return post(getDocumentLineasWS);
};
